import {BaseService} from "../domain-services/base-service";
import {BootstrapSettings} from "../../core/bootstrap/models/bootstrap-settings";

export class BaseModuleSettings extends BaseService {
  bootstrapSettings: BootstrapSettings;

  constructor(bootstrapSettings: BootstrapSettings) {
    super();

    this.bootstrapSettings = bootstrapSettings;
  }
}
